import { MovieSettingsIcon } from './MovieSettingsIcon';

/**
 * author: Colton Wiscombe
 * id 0A90A107-BB52-4DBA-BC4F-E285D87EB4DF
 * name movie-settings
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-settings.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const SlateSettingsIcon = MovieSettingsIcon;
export default SlateSettingsIcon